<script>
import Drawer from "@/components/drawer";
import VueDropify from "vue-dropify";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";
import draggable from "vuedraggable";
import carousel from "vue-owl-carousel";
import moment from "moment";
import { required, requiredIf, url } from "vuelidate/lib/validators";
import { Chrome } from "vue-color";

// Custom components
import CategoryPage from "./mockit.vue";
import TemplateData from "./template.vue";
import LightBox from "@/components/hotel/lightBox.vue";
import { authComputed, authMethods } from "@/state/helpers";
import { icons } from "./data-fontawesome";
import { page_conditions } from "@/helpers/global.variable";
import GXPService from "@/helpers/APIService/gxp.service";
import UserService from "@/helpers/APIService/user.service";
import hotelService from "@/helpers/APIService/hotel.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";

export default {
  page: {
    title: "homePage",
  },
  components: {
    Drawer,
    VueDropify,
    MultiSelect,
    carousel,
    draggable,
    CategoryPage,
    TemplateData,
    LightBox,
    "chrome-picker": Chrome,
  },
  data() {
    return {
      guest_xp_bg_image: null,
      guestXPBgImgLoading: false,
      colors: "",
      icons: icons,
      conditionOption: page_conditions,
      typeBaseIcons: null,
      greeting: null,
      // TEMPLATE COLOR AND OTHER COMMON VARIABLES
      selectedTemplate: null,
      templateOptions: [
        {
          id: 1,
          title: "Template With Box View",
          img: "template_1",
          template_type: "box_view",
          is_img_template: false,
          is_icon_template: true,
          insideHtml: `
            <div class="container">
              <draggable :list="PageData" :disabled="!isOnTemplate" @change="afterMove" class="d-flex align-items-center flex-wrap justify-content-center">
                <template v-for="(menu, index) in PageData">
                  <div :key="index" class="" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" @click="openDropdown(menu)">
                    <div class="mobile-box-card d-flex align-items-center justify-content-center text-dark template-theme-border template-menu-bg cursor position-relative p-1">
                      <b-dropdown ref="myDropdown" v-if="menu.isShowEdit" class="mb-0 template-dropdown" toggle-class="btn btn-link text-muted" menu-class="dropdown-menu-end" right variant="white">
                        <template #button-content><i class="mdi mdi-dots-vertical font-size-20"></i></template>
                        <b-dropdown-item href="#" @click="openCategory(menu)">Open</b-dropdown-item>
                        <b-dropdown-item href="#" @click="editPage(menu, true, index)">Edit</b-dropdown-item>
                        <b-dropdown-item href="#" v-if="menu.is_active_super_panel == undefined" @click="deletePage(menu)">Delete</b-dropdown-item>
                      </b-dropdown>
                        <div class="text-center">
                          <i :class="menu.icon!==null?menu.icon:menu.app_feature_icon" class="mb-2 fs-4 template-theme-icon"></i>
                          <p class="mb-0 template-menu-font text-break font-size-12">{{ menu.name }}</p>
                        </div>
                    </div>
                  </div>
                </template>
                <div class="" v-if="isShowAddNew">
                  <div class="mobile-box-card d-flex align-items-center justify-content-center cursor card" @click="addPage()">
                    <div class="text-center">
                      <i class="fas fa-plus mb-2 fs-4"></i>
                      <p class="text-dark mb-0">New Add</p>
                    </div>
                  </div>
                </div>
              </draggable>
                <div class="mt-2 px-2 mb-3">
                  <button class="hotel-btn w-100 btn p-2 fs-5">Logout</button>
                </div>
            </div>`,
        },
        {
          id: 2,
          title: "Template With List View",
          img: "template_4",
          template_type: "list_view",
          is_img_template: false,
          is_icon_template: false,
          insideHtml: `
          <div class="px-3">
            <draggable :list="PageData" :disabled="!isOnTemplate" @change="afterMove" class="row">
            <template v-for="(menu, index) in PageData">
                <div :key="index" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" @click="openDropdown(menu)">
                <div class="template-menu-bg template-theme-border p-3 border rounded-3 mb-3 cursor position-relative">
                  <b-dropdown :id='String(index)' ref="myDropdown" v-if="menu.isShowEdit" class="mb-0 template-dropdown" toggle-class="btn btn-link text-muted" menu-class="dropdown-menu-end" right variant="white">
                    <template #button-content><i class="mdi mdi-dots-vertical font-size-20"></i></template>
                    <b-dropdown-item href="#" @click="openCategory(menu)" >Open</b-dropdown-item>
                    <b-dropdown-item href="#" @click="editPage(menu, true, index)">Edit</b-dropdown-item>
                    <b-dropdown-item href="#" v-if="menu.is_active_super_panel == undefined" @click="deletePage(menu)">Delete</b-dropdown-item>
                  </b-dropdown>
                  <div class="text-center">
                    <h6 class="mb-0 template-menu-font text-break">{{ menu.name }}</h6>
                  </div>
                </div>
              </div>
            </template>
          </draggable>
          <div class="p-3 card rounded-3 mb-3 cursor" v-if="isShowAddNew">
            <div class="d-flex align-items-center justify-content-center" @click="addPage()">
              <i class="fas fa-plus me-2 fs-5"></i>
              <h6 class="mb-0">New Add</h6>
            </div>
          </div>
          <div class="mb-3">
            <button class="hotel-btn w-100 btn p-2 fs-5">Logout</button>
          </div>
        </div>`,
        },
        {
          id: 3,
          title: "Template With Image List View",
          img: "template_2",
          template_type: "image_list_view",
          is_img_template: true,
          is_icon_template: false,
          insideHtml: `
          <div class="px-3">
            <draggable :list="PageData" :disabled="!isOnTemplate" @change="afterMove" class="row">
              <template v-for="(menu, index) in PageData">
                <div :key="index" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" @click="openDropdown(menu)">
                  <div class="second-template position-relative cursor mb-2" :style="{'background-image': getImage(menu.image),}">
                    <b-dropdown ref="myDropdown" v-if="menu.isShowEdit" class="mb-0 template-dropdown" toggle-class="btn btn-link text-muted" menu-class="dropdown-menu-end" right variant="white">
                      <template #button-content><i class="mdi mdi-dots-vertical font-size-20"></i></template>
                      <b-dropdown-item href="#" @click="openCategory(menu)" >Open</b-dropdown-item>
                      <b-dropdown-item href="#" @click="editPage(menu, true, index)">Edit</b-dropdown-item>
                      <b-dropdown-item href="#" v-if="menu.is_active_super_panel == undefined" @click="deletePage(menu)">Delete</b-dropdown-item>
                    </b-dropdown>
                    <h6 class="bg-template-text mb-0 template-menu-font text-break">{{ menu.name }}</h6>
                  </div>
                </div>
              </template>
            </draggable>
            <div class="card new-second-template bg-white p-2 cursor align-items-center justify-content-center mb-2" v-if="isShowAddNew">
              <div class="d-flex align-items-center justify-content-center" @click="addPage()">
              <i class="fas fa-plus me-2"></i>
              <h5 class="mb-0">New Add</h5>
              </div>
            </div>
            <div class="mb-3">
              <button class="hotel-btn w-100 btn p-2 fs-5">Logout</button>
            </div>
          </div>`,
        },
        {
          id: 4,
          title: "Template With Image Box View",
          img: "template_3",
          template_type: "image_box_view",
          is_img_template: true,
          is_icon_template: false,
          insideHtml: `
            <div class="container px-3">
              <draggable :list="PageData" :disabled="!isOnTemplate" @change="afterMove" class="row justify-content-center">
                <template v-for="(menu, index) in PageData">
                  <div :key="index" class="col-md-6 px-2" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" @click="openDropdown(menu)">
                    <div class="third-template cursor position-relative mb-3" :style="{'background-image': getImage(menu.image),}">
                      <b-dropdown ref="myDropdown" v-if="menu.isShowEdit" class="mb-0 template-dropdown" toggle-class="btn btn-link text-muted" menu-class="dropdown-menu-end" right variant="white">
                          <template #button-content><i class="mdi mdi-dots-vertical font-size-20"></i></template>
                          <b-dropdown-item href="#" @click="openCategory(menu)" >Open</b-dropdown-item>
                          <b-dropdown-item href="#" @click="editPage(menu, true, index)">Edit</b-dropdown-item>
                          <b-dropdown-item href="#" v-if="menu.is_active_super_panel == undefined" @click="deletePage(menu)">Delete</b-dropdown-item>
                      </b-dropdown>
                      <p class="bg-template-text w-100 mb-0 template-menu-font text-break">{{ menu.name }}</p>
                    </div>
                  </div>
                </template>
                <div class="col-md-6 px-2" v-if="isShowAddNew">
                  <div class="card New-add-third-template bg-white cursor d-flex align-items-center justify-content-center" @click="addPage()">
                    <div class="text-center">
                      <i class="fas fa-plus"></i>
                      <h5 class="mb-0">New Add</h5>
                    </div>
                  </div>
                </div>
              </draggable>
              <div class="mb-3">
                <button class="hotel-btn w-100 btn p-2 fs-5">Logout</button>
              </div>
            </div>
          `,
        },
      ],
      isOnTemplate: true,
      brandWiseThemes: [],
      selectedTheme: null,
      colorSetting: {},
      headerData: null,
      headerDataImages: [],
      headerImageLoading: false,
      headerBGImageLoading: false,
      submittedHeaderData: false,
      isHeaderDataBtnLoading: false,
      isResetBtnLoading: false,
      bottomDrawer: false,
      // PAGE RELATED VARIABLES
      Pages: [],
      PageTitle: "Add New Page",
      pageDrawerOpen: false,
      PageData: {
        name: null,
        image: null,
        icon: null,
        page_condition: null,
      },
      page_template_type: null,
      isPageEdit: false,
      isShowCategory: false,
      editIndex: null,
      selectedColor: "#003D80",
      selectedIndex: 0,
      backgroundImage: null,
      // Add New Page and Open/Close Category page
      categoryToShow: null,
      submittedButtonData: false,
      isButtonDataBtnLoading: false,
      imgUrl: null,
      logoImg: null,

      // Color Picker Display
      showColorPicker: false,

      // Light Box Related Variables
      isShowLightBox: false,
      lightBoxPageOptions: [
        { text: "Main Page", value: "main_page", type: "text" },
      ],
    };
  },
  validations: {
    PageData: {
      name: {
        required,
      },
      icon: {
        required: requiredIf(function () {
          if (
            this.selectedTemplate !== null &&
            this.selectedTemplate.is_icon_template
          ) {
            return true;
          }
        }),
      },
      image: {
        required: requiredIf(function () {
          if (
            this.selectedTemplate !== null &&
            this.selectedTemplate.is_img_template
          ) {
            return true;
          }
        }),
      },
      redirect_url: {
        required: requiredIf(function () {
          if (this.page_template_type == "redirect_url") {
            return true;
          }
        }),
        url,
      },
    },
  },
  computed: {
    ...authComputed,
    cardProps() {
      return {
        backgroundImage: this.backgroundImage,
        categoryToShow: this.categoryToShow,
        lightBoxPageOptions: this.lightBoxPageOptions,
      };
    },
    lightBoxData() {
      return {
        lightBoxPageOptions: this.lightBoxPageOptions,
        openPageOptions: this.lightBoxPageOptions,
        selectedPage: "main_page",
      };
    },
  },
  mounted() {
    this.$root.$on("openCategory", (data) => {
      this.openCategory(data);
    });
    this.$root.$on("addPage", () => {
      this.addPage();
    });
    this.$root.$on("editPage", (data) => {
      const { menu, status, index } = data;
      this.editPage(menu, status, index);
    });
    this.$root.$on("deletePage", (data) => {
      this.deletePage(data);
    });
    this.$root.$on("categoryMove", () => {});
    if (localStorage.isOnTemplate !== undefined) {
      this.isOnTemplate =
        localStorage.getItem("isOnTemplate") == "false" ? false : true;
    }
    this.$root.$on("onTemplate", () => {
      this.isOnTemplate = false;
    });
    this.setHeaderData();
    this.setValue();
  },
  methods: {
    ...authMethods,
    /** TEMPLATE RELATED METHODS */

    // Method is used to set header data
    async setHeaderData() {
      try {
        let data = [];
        const response = await GXPService.getFeature();
        if (
          response[0].feature_code === 101 &&
          response[0].is_active_super_panel &&
          response[0].is_plan_purchased &&
          response[0].is_active
        ) {
          const menu = await GXPService.getPages("?page_level=1");
          if (menu.length !== 0) {
            data = menu;
          }
        }
        response.map((item) => {
          let isShow = false;
          if (item.is_active_super_panel && item.is_plan_purchased) {
            if (item.end_date !== null) {
              if (
                moment().format("YYYY-MM-DD") !==
                moment(item.end_date).format("YYYY-MM-DD")
              ) {
                isShow = true;
              }
            } else {
              isShow = true;
            }
          }
          this.Pages.push({ ...item, isShow: isShow });
        });
        if (data.length !== 0) {
          this.Pages = [...this.Pages, ...data];
        }
        this.Pages.map((item) => {
          if (item.feature_code !== 101) {
            if (item.feature_code !== undefined) {
              if (
                item.is_active &&
                item.is_active_super_panel &&
                item.is_plan_purchased
              ) {
                this.lightBoxPageOptions.push({
                  text: item.name,
                  value: item.feature_code,
                  type: "number",
                });
              }
            } else {
              this.lightBoxPageOptions.push({
                text: item.name,
                value: item.id,
                type: "uuid",
              });
            }
          }
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to set values
    setValue() {
      this.templateOptions.map((temp) => {
        if (
          temp.template_type == this.hotel.hotel_directory_setting.template_type
        ) {
          this.selectedTemplate = temp;
        }
      });
      this.headerData = {
        ...this.hotel.hotel_directory_setting,
      };
      if (this.hotel.brand.name !== "Other") {
        UserService.getBrandWiseThemes(this.hotel.brand.id)
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                this.brandWiseThemes.push({
                  text: item.name,
                  value: item.color_setting,
                });
              });
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      } else {
        UserService.getAllThemes()
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                this.brandWiseThemes.push({
                  text: item.name,
                  value: item.color_setting,
                });
              });
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
      this.manageColors(this.headerData.color_setting);
      this.changeHeaderImageMode();
      setInterval(() => {
        const date = new Date();
        let hour = date.getHours();
        if (hour < 12) {
          this.greeting = "Good Morning!";
        }
        if (hour === 12) {
          this.greeting = "Good Afternoon!";
        }
        if (hour > 12) {
          this.greeting = "Good Afternoon!";
        }
        if (hour > 18) {
          this.greeting = "Good Evening!";
        }
      }, 1000);
      this.logoImg = this.hotel.logo;
      this.guest_xp_bg_image = this.hotel.guest_xp_bg_image;
    },
    // Method is used for select theme
    themeChange() {
      if (this.selectedTheme !== null) {
        this.manageColors(this.selectedTheme.value);
      } else {
        this.manageColors(this.headerData.color_setting);
      }
    },
    // Method is use for get static image and return to use in image tag
    getImage(image) {
      return require("../../assets/images/templates/" + image + ".png");
    },
    // Method is used for manage colors
    manageColors(colors) {
      this.colorSetting = {
        theme: colors["theme"],
        theme_font: colors["theme_font"],
        theme_icon: colors["theme_icon"],
        title_bg: colors["title_bg"],
        title_font: colors["title_font"],
        theme_border: colors["theme_border"],
        menu_bg: colors["menu_bg"],
        menu_font: colors["menu_font"],
        btn_bg: colors["btn_bg"],
        btn_font: colors["btn_font"],
        btn_border: colors["btn_border"],
      };
      // this.selectedColor = { color: colors["theme"], index: "theme" };
      if (typeof colors == "object") {
        Object.keys(colors).map((key) => {
          this.setThemeColor(key, colors[key]);
        });
      }
    },
    // Method is used to update colors
    updateColor(index) {
      this.selectedColor = this.colorSetting[index];
      this.selectedIndex = index;
      this.showColorPicker = true;
    },
    // Method is use for change dynamic color by status
    colorChange(color, type) {
      Object.keys(this.colorSetting).map((key) => {
        if (key == type) {
          this.colorSetting[key] = color.hex8;
        }
      });
      this.setThemeColor(type, color.hex8);
      this.selectedColor = color;
      this.selectedIndex = type;
      // this.showColorPicker = false;
    },
    // Method is used to handle change header image
    changeHeaderImage(event, type) {
      if (event[0] !== undefined) {
        const headerImageData = new FormData();
        if (type == "is_bg_img") {
          this.headerBGImageLoading = true;
          if (this.backgroundImage !== null) {
            hotelService.deletePageHeaderImage(this.backgroundImage.id);
            this.backgroundImage = null;
          }
        }
        if (type !== "hotel_logo") {
          headerImageData.append("is_bg_image", 1);
        } else {
          this.headerImageLoading = true;
        }
        headerImageData.append("hotel", this.hotel.id);
        headerImageData.append("image", event[0]);
        if (type !== "hotel_logo") {
          hotelService
            .addPageHeaderImages(headerImageData)
            .then((response) => {
              if (type !== "is_bg_img") {
                this.headerDataImages.push(response);
              } else {
                this.backgroundImage = response;
                this.headerBGImageLoading = false;
              }
              this.headerImageLoading = false;
              Middleware.notification(
                "Image uploaded successfully !!",
                "success"
              );
            })
            .catch((error) => {
              this.headerImageLoading = false;
              this.headerBGImageLoading = false;
            });
        } else {
          const imageData = new FormData();
          imageData.append("logo", event[0]);
          hotelService.updateHotelDetails(imageData).then((response) => {
            this.logoImg = response.logo;
          });
        }
        setTimeout(() => {
          document.querySelector(".has-icon").click();
        }, 500);
      } else {
        if (type == "is_bg_img") {
          if (this.backgroundImage !== null) {
            hotelService.deletePageHeaderImage(this.backgroundImage.id);
            this.backgroundImage = null;
          }
        }
      }
    },
    // Method is used to reset header data
    resetHeaderData() {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to reset data!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes !",
      }).then((result) => {
        if (result.value) {
          this.isResetBtnLoading = false;
          Middleware.notification("Template successfully reset !!", "success");
        }
      });
    },
    // Method is use for change between template setting and portal setting
    changeTemMode() {
      this.isShowLightBox = false;
      this.isOnTemplate = !this.isOnTemplate;
      localStorage.setItem("isOnTemplate", this.isOnTemplate);
      this.$root.$emit("changeTemMode", this.isOnTemplate);
    },
    // Method is used to handle image view change
    changeHeaderImageMode() {
      this.headerDataImages = [];
      hotelService
        .getPageHeaderImages()
        .then((response) => {
          response.map((item) => {
            if (item.is_bg_image) {
              this.backgroundImage = item;
            } else {
              this.headerDataImages.push(item);
            }
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use to handle header form data submission
    handleHeaderSubmit() {
      this.submittedHeaderData = true;
      this.isHeaderDataBtnLoading = true;
      this.submittedHeaderData = false;
      const headerFormData = new FormData();
      this.headerData.template_type = this.selectedTemplate.template_type;
      this.headerData.is_update_color_setting = true;
      this.headerData = {
        ...this.headerData,
        color_setting: this.colorSetting,
      };
      headerFormData.append(
        "hotel_directory_setting",
        JSON.stringify(this.headerData)
      );
      hotelService
        .updateHotelDetails(headerFormData)
        .then((response) => {
          this.headerData = { ...response.hotel_directory_setting };
          Middleware.notification(
            "Successfully saved your template !!",
            "success"
          );

          Middleware.notification(
            "Continue customizing your portal...",
            "info"
          );

          this.changeTemMode();
          this.isHeaderDataBtnLoading = false;
        })
        .catch((error) => {
          this.isHeaderDataBtnLoading = false;
          this.isError = true;
          this.errorMessage = error.response.data;
        });
    },
    // Method is use to manage multi image movement
    onChoose: function (evt) {
      Middleware.notification("Positions changed !!", "success");
    },
    // Method is use to delete image from multi image
    deleteHeaderImage(image) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete image!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          await hotelService
            .deletePageHeaderImage(image.id)
            .then((response) => {
              this.headerDataImages = this.headerDataImages.filter(
                (img) => img.id !== image.id
              );
              Middleware.notification(
                "Image deleted successfully !!",
                "danger"
              );
            })
            .catch((error) => errorHandler(error));
        }
      });
    },
    // Method is use to change guest xp background image
    changeGuestXPBgImage(event) {
      if (event[0] !== undefined) {
        this.guestXPBgImgLoading = true;
        const hotelData = new FormData();
        hotelData.append("guest_xp_bg_image", event[0]);
        hotelService
          .updateHotelDetails(hotelData)
          .then((response) => {
            this.guestXPBgImgLoading = false;
            this.guest_xp_bg_image = response.guest_xp_bg_image;
            this.setHotel().then(() => {});
            Middleware.notification(
              "Image uploaded successfully !!",
              "success"
            );
          })
          .catch((error) => {
            this.guestXPBgImgLoading = false;
            errorHandler(error);
          });
      }
    },

    /** INSIDE FIRST LAYER RELATED METHODS */

    // Method is use to handle add menu page data
    addPage() {
      this.pageDrawerOpen = !this.pageDrawerOpen;
    },
    // Method is use to handle edit menu page data
    editPage(data = null, isEdit, index) {
      if (data !== null && isEdit) {
        this.editIndex = index;
        this.PageTitle = "Main Page / " + data.name;
        this.PageData = { ...data };
        this.page_template_type = this.PageData.page_template_type;
      } else {
        this.PageTitle = "Add New Page";
        this.PageData = {
          name: null,
          image: null,
          icon: null,
          page_condition: null,
        };
      }
      this.isPageEdit = isEdit;
      this.pageDrawerOpen = !this.pageDrawerOpen;
    },
    // Method is used to set selected template list
    selectedListType(type) {
      this.page_template_type = type;
    },
    // Method is used to handle form submission
    handleMenuPageDataSubmit() {
      this.submittedButtonData = true;
      this.isButtonDataBtnLoading = true;
      this.$v.$touch();
      if (this.$v.PageData.$invalid) {
        this.isButtonDataBtnLoading = false;
        return;
      } else {
        this.submittedButtonData = false;
        this.isButtonDataBtnLoading = true;
        const PageData = new FormData();
        PageData.append("hotel", this.hotel.id);
        if (this.PageData.icon !== null) {
          PageData.append("icon", this.PageData.icon);
        }
        PageData.append("name", this.PageData.name);
        if (this.page_template_type == "redirect_url") {
          PageData.append("redirect_url", this.PageData.redirect_url);
        }
        if (this.selectedTemplate.is_img_template) {
          if (this.imgUrl !== null) PageData.append("image", this.imgUrl);
        }
        if (this.PageData.page_condition !== null) {
          PageData.append(
            "page_condition",
            JSON.stringify(this.PageData.page_condition)
          );
        }
        if (this.page_template_type !== null) {
          PageData.append("page_template_type", this.page_template_type);
          PageData.append("page_level", 1);
        } else {
          PageData.append("page_template_type", "list_page_one");
          PageData.append("page_level", 1);
        }
        if (this.isPageEdit) {
          // UPDATE FEATURE AND PAGE API CALL
          if (this.PageData.is_active_super_panel == undefined) {
            GXPService.updatePage(this.PageData.id, PageData)
              .then((response) => {
                this.updatePageDataHelper(response, "map");
                this.isButtonDataBtnLoading = false;
                this.submittedButtonData = false;
                this.editPage();
              })
              .catch((error) => {
                errorHandler(error);
              });
          } else {
            GXPService.UpdateFeature(this.PageData.id, PageData)
              .then((response) => {
                this.updatePageDataHelper(response, "map");
                this.isButtonDataBtnLoading = false;
                this.submittedButtonData = false;
                this.editPage();
              })
              .catch((error) => {
                this.isButtonDataBtnLoading = false;
                this.submittedButtonData = false;
                errorHandler(error);
              });
          }
          this.Pages = this.Pages.map((item, index) => {
            if (index == this.editIndex) {
              item = {
                ...this.PageData,
                is_active: true,
                id: item.id,
                position: item.position,
              };
            }
            return item;
          });
        } else {
          // ADD NEW PAGE API CALL
          PageData.append("is_active", true);
          GXPService.addPage(PageData)
            .then((response) => {
              this.isButtonDataBtnLoading = false;
              this.submittedButtonData = false;
              this.updatePageDataHelper(response, "push");
              this.editPage();
            })
            .catch((error) => {
              this.isButtonDataBtnLoading = false;
              this.submittedButtonData = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is used ot change status
    changeStatus(data) {
      if (data.is_active_super_panel == undefined) {
        UserService.updatePage(data.id, { is_active: !data.is_active })
          .then((response) => {
            this.updatePageDataHelper(response, "map");
          })
          .catch((error) => {
            errorHandler(error);
          });
      } else {
        if (data.isShow) {
          GXPService.UpdateFeature(data.id, { is_active: !data.is_active })
            .then((response) => {
              if (response.feature_code == 101) {
                this.$router.go();
              } else {
                this.updatePageDataHelper(response);
                Middleware.notification(
                  "Status Changed successfully !!",
                  "success"
                );
              }
            })
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          Middleware.notification("You can't change !!", "danger");
        }
      }
    },
    // Method is used to delete menu
    deletePage(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete image!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          GXPService.deletePage(data.menu.id)
            .then(() => {
              Middleware.notification("Deleted successfully !!", "success");

              this.updatePageDataHelper(data, "filter");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle image change event
    changeMenuPageDataImage(event) {
      if (event[0] !== undefined) {
        this.imgUrl = event[0];
        this.PageData.image = window.URL.createObjectURL(event[0]);
      }
    },

    /** ADD NEW PAGE AND OPEN CATEGORY PAGE RELATED METHODS */

    // Method is used to open category
    openCategory(data) {
      if (this.page_template_type == "redirect_url") {
        window.open(data.redirect_url, "_blank");
      } else {
        this.categoryToShow = data;
        const featureCodes = [118, 119, 120];
        if (featureCodes.includes(data.feature_code)) {
          this.bottomDrawer = !this.bottomDrawer;
        } else {
          this.isShowCategory = !this.isShowCategory;
          this.changeTemMode();
        }
      }
    },
    // Method is used to handle light box
    openLightBox() {
      this.isShowLightBox = !this.isShowLightBox;
    },
    addNewLightBox() {
      this.$root.$emit("addNewLightBox", true);
    },
    // EXTRA METHODS (HELPER)

    // Method is used to update data
    updatePageDataHelper(data, method) {
      if (method == "map") {
        this.Pages = this.Pages.map((item) => {
          if (item.id === data.id) {
            item = data;
          }
          return item;
        });
        Middleware.notification("changes applied successfully !!", "success");
      }
      if (method == "filter") {
        this.Pages = this.Pages.filter((item) => item.id !== data.menu.id);
      }
      if (method == "push") {
        this.Pages.push(data);
      }
      const Pages = [];
      let index = 0;
      const featureCodes = [102, 106, 112, 113, 114, 116, 117];
      this.Pages.map((item) => {
        if (featureCodes.includes(item.feature_code)) {
          item = { ...item, isShowEdit: false };
        } else {
          item = { ...item, isShowEdit: true, extraIndex: index };
          index += 1;
        }
        Pages.push(item);
      });
      this.$root.$emit("updateMenuData", Pages);
    },
    // Method is used to set icons
    setIcons() {
      let brand = [];
      let solid = [];
      let regular = [];
      for (let entry of icons) {
        if (entry.attributes.membership.free.length && entry.id != undefined) {
          for (let value of entry.attributes.membership.free) {
            switch (value) {
              case "brands":
                brand.push({ icon: `fab fa-${entry.id}`, show: entry.id });
                break;
              case "solid":
                solid.push({ icon: `fas fa-${entry.id}`, show: entry.id });
                break;
              default:
                regular.push({ icon: `far fa-${entry.id}`, show: entry.id });
            }
          }
        }
      }
      this.typeBaseIcons = [
        {
          iconName: "brands",
          icons: brand,
        },
        { iconName: " solid", icons: solid },
        { iconName: "regular", icons: regular },
      ];
    },
    // Method is used to set single icon
    setIcon(icon) {
      this.PageData.icon = icon.icon;
      this.$bvModal.hide("icon-list-modal");
    },
    // Method is used for make template option label dynamic
    customLabel({ title }) {
      return `${title}`;
    },
    // Method is used for set template theme color
    setThemeColor(type, color) {
      let bodyStyles = document.body.style;
      bodyStyles.setProperty(`--template-${type.replaceAll("_", "-")}`, color);
    },
    getVal() {
      return this.selectedColor.color;
    },
  },
};
</script>

<template>
  <div>
    <b-card class="card-height mb-3">
      <!-- Design page -->
      <div v-if="!isShowCategory">
        <div class="row">
          <div class="col-xl-5 col-lg-6">
            <div class="iphone" v-if="isOnTemplate">
              <div class="iphone-top">
                <span class="camera"></span>
                <span class="sensor"></span>
                <span class="speaker"></span>
              </div>
              <div class="top-bar"></div>
              <div class="position-relative">
                <div
                  :class="
                    backgroundImage !== null ? 'bg-img' : 'template-theme'
                  "
                  :style="{
                    'background-image': `url(${
                      backgroundImage !== null ? backgroundImage.image : ''
                    })`,
                  }"
                >
                  <div class="iphone-screen" v-if="headerData !== null">
                    <div class="py-2 px-4 position-relative template-title-bg">
                      <p class="fw-bold mb-0 text-center template-title-font">
                        {{ headerData.title }}
                      </p>
                    </div>
                    <div class="mobile-box position-relative">
                      <div class="m-2 p-1 text-center position-relative">
                        <img :src="hotel.logo" alt="" class="img-logo" />

                        <p class="my-3 template-theme-font">
                          {{ greeting }} Guest Name
                        </p>
                        <div class="btn-group">
                          <div class="floating-btn">
                            <i class="fas fa-home font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-map-marked-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-phone-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-share-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-cloud font-size-18"></i>
                          </div>
                        </div>
                        <div class="my-3">
                          <img
                            v-if="headerData.isSingleImg"
                            :src="hotel.logo"
                            alt=""
                            class="img-logo"
                          />
                          <div v-else>
                            <carousel
                              :autoplay="
                                headerDataImages.length != 1 ? true : false
                              "
                              :loop="
                                headerDataImages.length != 1 ? true : false
                              "
                              :nav="false"
                              :dots="false"
                              :responsive="{ 0: { items: 1 } }"
                              :key="headerDataImages.length"
                            >
                              <img
                                v-for="(img, index) in headerDataImages"
                                :src="img.image"
                                :key="index"
                                class="banner-img object-fit rounded"
                              />
                            </carousel>
                          </div>
                        </div>
                        <div
                          class="card template-menu-bg template-theme-border booking-box mb-0"
                        >
                          <div class="card-body">
                            <h5 class="template-menu-font mb-4">
                              Booking# <span>WEXCF45J</span>
                            </h5>
                            <div class="d-flex justify-content-center">
                              <div>
                                <label class="template-menu-font mb-2"
                                  >Check In</label
                                >
                                <div
                                  class="card date-box mb-0 template-menu-bg template-theme-border d-flex align-items-center justify-content-center"
                                >
                                  <div>
                                    <h2 class="template-menu-font">20</h2>
                                    <p class="template-menu-font mb-0">
                                      February
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <label class="template-menu-font mb-2"
                                  >Check Out</label
                                >
                                <div
                                  class="card date-box mb-0 template-menu-bg template-theme-border d-flex align-items-center justify-content-center"
                                >
                                  <div>
                                    <h2 class="template-menu-font">23</h2>
                                    <p class="template-menu-font mb-0">
                                      February
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h6 class="template-menu-font font-size-16 my-4">
                              Super King Bed
                            </h6>
                            <button class="btn booking-btn w-100">
                              Booking Detail
                            </button>
                          </div>
                        </div>
                      </div>
                      <template v-if="Pages.length == 0">
                        <div
                          class="d-flex align-items-center flex-wrap justify-content-center"
                        >
                          <div
                            v-for="no in 10"
                            :key="no"
                            class="placeholder-glow mobile-box-card m-1"
                          >
                            <span
                              class="placeholder placeholder-lg mobile-box-card m-0"
                            ></span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <TemplateData
                          :Pages="Pages"
                          :html="selectedTemplate.insideHtml"
                          :key="selectedTemplate.id"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                <!-- <div class="light-box-overlay">
                      <div class="light-box-modal">
                        <div class="light-box">
                          <img
                            src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg"
                            atl=""
                          />
                        </div>
                      </div>
                    </div> -->
                <div class="float-btn cursor" @click="openLightBox">
                  <i class="fas fa-box"></i>
                </div>

                <!-- ac, light, tv remote drawer -->
                <div class="bottom-drawer">
                  <div class="body-area" v-show="bottomDrawer">
                    <div
                      class="row"
                      v-if="
                        categoryToShow && categoryToShow.feature_code == 118
                      "
                    >
                      <h5 class="text-light text-center mt-3">Light Control</h5>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="dripicons-gear"></i>
                          </div>
                          <p class="text-light mt-2">Day</p>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="far fa-moon"></i>
                          </div>
                          <p class="text-light mt-2">Night</p>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="fas fa-power-off"></i>
                          </div>
                          <p class="text-light mt-2">Off</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="
                        categoryToShow && categoryToShow.feature_code == 119
                      "
                    >
                      <h5 class="text-light text-center mt-3">
                        Current Room Temp 40
                      </h5>
                      <input
                        type="range"
                        id="roomInputId"
                        value="24"
                        min="1"
                        max="100"
                        class="control-range my-3"
                        oninput="roomOutputId.value = roomInputId.value"
                      />
                      <div
                        class="d-flex align-items-center justify-content-center text-light"
                      >
                        <span class="me-2">Set Temp</span>
                        <output id="roomOutputId" class="d-block fw-bolder"
                          >24</output
                        >
                      </div>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="fas fa-snowflake"></i>
                          </div>
                          <p class="text-light mt-2">Cool</p>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="fas fa-fire"></i>
                          </div>
                          <p class="text-light mt-2">Heat</p>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-4">
                          <div class="control-box">
                            <i class="fas fa-power-off"></i>
                          </div>
                          <p class="text-light mt-2">Off</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-2"
                      v-if="
                        categoryToShow && categoryToShow.feature_code == 120
                      "
                    >
                      <h5 class="text-center text-light mb-2">TV Remote</h5>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box">
                            <i class="fas fa-power-off"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box">
                            <i class="fas fa-microphone-slash"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box">
                            <i class="bx bxl-chrome"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">1</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">2</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">3</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">4</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">5</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">6</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">7</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">8</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">9</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box">
                            <i class="dripicons-plus fs-3"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box fs-3">0</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center my-2">
                          <div class="control-box">
                            <i class="dripicons-minus fs-3"></i>
                          </div>
                        </div>
                      </div>
                      <span class="text-center d-block text-light">Volume</span>
                      <input
                        type="range"
                        id="roomInputId"
                        value="24"
                        min="1"
                        max="100"
                        class="control-range my-3"
                        oninput="roomOutputId.value = roomInputId.value"
                      />

                      <output
                        id="roomOutputId"
                        class="d-block fw-bold text-center text-light mb-2"
                        >24</output
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttons">
                <span class="on-off"></span>
                <span class="sleep"></span>
                <span class="up"></span>
                <span class="down"></span>
              </div>
              <div class="bottom-bar"></div>
              <div class="iphone-bottom">
                <span></span>
              </div>
            </div>
            <div class="iphone" v-if="!isOnTemplate">
              <div class="iphone-top">
                <span class="camera"></span>
                <span class="sensor"></span>
                <span class="speaker"></span>
              </div>
              <div class="top-bar"></div>
              <div class="position-relative">
                <div
                  :class="
                    backgroundImage !== null ? 'bg-img' : 'template-theme'
                  "
                  :style="{
                    'background-image': `url(${
                      backgroundImage !== null ? backgroundImage.image : ''
                    })`,
                  }"
                >
                  <div class="iphone-screen">
                    <div class="py-2 px-4 position-relative template-title-bg">
                      <p class="fw-bold mb-0 text-center template-title-font">
                        {{ headerData.title }}
                      </p>
                      <i
                        class="fas fa-palette edit-icon template-title-font fs-4 ps-4"
                        style="width: 50px"
                        @click="changeTemMode()"
                      ></i>
                    </div>
                    <div class="mobile-box">
                      <div class="p-3 text-center position-relative">
                        <img :src="hotel.logo" alt="" class="img-logo" />

                        <p class="my-3 template-theme-font">
                          {{ greeting }} Guest Name
                        </p>
                        <div class="btn-group">
                          <div class="floating-btn">
                            <i class="fas fa-home font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-map-marked-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-phone-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-share-alt font-size-18"></i>
                          </div>
                          <div class="floating-btn">
                            <i class="fas fa-cloud font-size-18"></i>
                          </div>
                        </div>
                        <div class="my-3">
                          <img
                            v-if="headerData.isSingleImg"
                            :src="hotel.logo"
                            alt=""
                            class="img-logo"
                          />
                          <div v-else>
                            <carousel
                              :autoplay="true"
                              :loop="true"
                              :nav="false"
                              :dots="false"
                              :responsive="{ 0: { items: 1 } }"
                              :key="headerDataImages.length"
                            >
                              <img
                                v-for="(img, index) in headerDataImages"
                                :src="img.image"
                                :key="index"
                                class="banner-img object-fit rounded"
                              />
                            </carousel>
                          </div>
                        </div>
                        <div
                          class="card template-menu-bg template-theme-border booking-box mb-0"
                        >
                          <div class="card-body">
                            <h5 class="template-menu-font mb-4">
                              Booking# <span>WEXCF45J</span>
                            </h5>
                            <div class="d-flex justify-content-center">
                              <div>
                                <label class="template-menu-font mb-2"
                                  >Check In</label
                                >
                                <div
                                  class="card date-box mb-0 template-menu-bg template-theme-border d-flex align-items-center justify-content-center"
                                >
                                  <div>
                                    <h2 class="template-menu-font">20</h2>
                                    <p class="template-menu-font mb-0">
                                      February
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <label class="template-menu-font mb-2"
                                  >Check Out</label
                                >
                                <div
                                  class="card date-box mb-0 template-menu-bg template-theme-border d-flex align-items-center justify-content-center"
                                >
                                  <div>
                                    <h2 class="template-menu-font">23</h2>
                                    <p class="template-menu-font mb-0">
                                      February
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h6 class="template-menu-font font-size-16 my-4">
                              Super King Bed
                            </h6>
                            <button class="btn booking-btn w-100">
                              Booking Detail
                            </button>
                          </div>
                        </div>
                      </div>
                      <template v-if="Pages.length == 0">
                        <div
                          class="d-flex align-items-center flex-wrap justify-content-center"
                        >
                          <div
                            v-for="no in 10"
                            :key="no"
                            class="placeholder-glow mobile-box-card shadow-none border-0 m-1"
                          >
                            <span
                              class="placeholder placeholder-lg mobile-box-card shadow-none border-0 m-0"
                            ></span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <TemplateData
                          :Pages="Pages"
                          :html="selectedTemplate.insideHtml"
                          :key="selectedTemplate.id"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                <div class="float-btn" @click="openLightBox">
                  <i class="fas fa-box"></i>
                </div>
              </div>
              <div class="buttons">
                <span class="on-off"></span>
                <span class="sleep"></span>
                <span class="up"></span>
                <span class="down"></span>
              </div>
              <div class="bottom-bar"></div>
              <div class="iphone-bottom">
                <span></span>
              </div>
            </div>
          </div>
          <div class="col-xl-7 col-lg-6">
            <div v-if="isOnTemplate" class="directory-scroll pe-3">
              <h4 class="mb-0" v-show="isShowLightBox">
                Home Page / Light Box
                <b-button
                  class="float-end"
                  variant="outline-primary"
                  type="submit"
                  @click="addNewLightBox"
                >
                  Add New
                </b-button>
              </h4>
              <hr v-if="isShowLightBox" />
              <LightBox v-if="isShowLightBox" :currentProps="lightBoxData" />
              <div class="row" v-else>
                <div class="col-md-6">
                  <h5 class="typo__label">Select Template</h5>
                  <MultiSelect
                    v-model="selectedTemplate"
                    placeholder="Select Template"
                    label="title"
                    track-by="title"
                    :options="templateOptions"
                    :option-height="104"
                    :custom-label="customLabel"
                    :show-labels="false"
                    :allow-empty="false"
                    class="multi-select-template"
                  >
                    <template slot="singleLabel" slot-scope="props"
                      ><img
                        class="option-image"
                        :src="getImage(props.option.img)"
                        :alt="props.option.title"
                      /><span class="ms-2">{{
                        props.option.title
                      }}</span></template
                    >
                    <template slot="option" slot-scope="props"
                      ><img
                        class="option-image"
                        :src="getImage(props.option.img)"
                        :alt="props.option.title"
                      />
                      <span class="ms-2">{{ props.option.title }}</span>
                    </template>
                  </MultiSelect>
                </div>
                <div class="col-md-6">
                  <label>SELECT THEME</label>
                  <MultiSelect
                    v-model="selectedTheme"
                    :options="brandWiseThemes"
                    placeholder="Select Template"
                    label="text"
                    track-by="value"
                    :show-labels="false"
                    @close="themeChange"
                  ></MultiSelect>
                </div>
              </div>

              <div class="mt-3" v-if="!isShowLightBox && headerData !== null">
                <form ref="header-form">
                  <div class="row">
                    <div class="col-md-12">
                      <h6>Set Color</h6>
                      <div class="d-flex flex-wrap align-items-center">
                        <b-form-group
                          v-for="(item, index) in colorSetting"
                          :key="index"
                          class="me-3 mb-3"
                          :label="index"
                          label-for="name-input"
                        >
                          <p slot="label" class="mb-2 text-capitalize">
                            {{
                              index == "theme_border"
                                ? "Menu Border"
                                : index.replaceAll("_", " ")
                            }}
                          </p>
                          <div class="position-relative">
                            <div class="border-gray cursor">
                              <div
                                class="color-box"
                                :class="[
                                  'color-box-' + index.replaceAll('_', '-'),
                                ]"
                                @click="updateColor(index)"
                              ></div>
                            </div>
                            <div
                              class="select-color"
                              v-if="selectedIndex == index && showColorPicker"
                            >
                              <chrome-picker
                                v-model="selectedColor"
                                @input="colorChange($event, selectedIndex)"
                              />
                              <div
                                class="update-color"
                                @click="showColorPicker = false"
                              >
                                <i class="fas fa-check text-light"></i>
                              </div>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                      <div class="row align-items-end mb-3">
                        <div class="col-md-6">
                          <label for="title">
                            Title <span class="text-danger">*</span>
                          </label>
                          <b-form-input
                            id="room_type"
                            type="text"
                            placeholder="Header Title"
                            autocomplete="off"
                            v-model="headerData.title"
                          ></b-form-input>
                        </div>
                        <div class="col-md-6">
                          <div class="d-flex">
                            <label for="single_multi_image" class="cursor mt-1"
                              >Multi</label
                            >
                            <div
                              class="form-check form-switch form-switch-md d-flex mb-3 ms-2"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="single_multi_image"
                                v-model="headerData.isSingleImg"
                                @change="changeHeaderImageMode"
                              />
                              <label
                                for="single_multi_image"
                                class="form-check-label"
                              >
                                Single Image
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6" v-if="headerData.isSingleImg">
                      <label for="images">Image</label>
                      <div class="dropify-upload-logo">
                        <VueDropify
                          @upload="changeHeaderImage($event, 'hotel_logo')"
                          :src="logoImg"
                          message="Drop image here or click to select"
                        />
                      </div>
                    </div>
                    <div class="col-md-12" v-else>
                      <draggable
                        class="row"
                        v-model="headerDataImages"
                        @change="onChoose"
                      >
                        <div
                          class="col-xl-3 col-lg-6 col-md-4 col-sm-6"
                          v-for="(image, index) in headerDataImages"
                          :key="index"
                        >
                          <div class="d-flex align-items-start mb-3">
                            <img
                              class="rounded cursor-move border common-upload-img-size object-fit w-100"
                              alt="hotel_info_image"
                              :src="image.image"
                              :id="index"
                              data-holder-rendered="true"
                            />
                            <div>
                              <i
                                class="mdi mdi-trash-can fs-5 text-danger"
                                v-if="headerDataImages.length > 1"
                                @click="deleteHeaderImage(image)"
                                slot="label"
                              ></i>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-xl-3 col-lg-6 col-md-4 col-sm-6"
                          draggable="true"
                        >
                          <div
                            class="position-relative plus-icon"
                            v-if="!headerImageLoading"
                          >
                            <VueDropify
                              @upload="changeHeaderImage($event)"
                              :src="imgUrl"
                              message="Drop image or click here to select"
                              height="150px"
                              id="headerData_images"
                              class="mb-3"
                            />
                            <i class="bx bx-plus fs-1"></i>
                          </div>
                          <div class="placeholder-glow" v-else>
                            <span
                              class="placeholder w-100 placeholder-lg common-upload-img-size"
                            ></span>
                          </div>
                        </div>
                      </draggable>
                    </div>
                    <div class="col-md-6">
                      <label for="images">Background Image</label>
                      <div v-if="!headerBGImageLoading">
                        <VueDropify
                          @upload="changeHeaderImage($event, 'is_bg_img')"
                          :src="
                            backgroundImage !== null
                              ? backgroundImage.image
                              : ''
                          "
                          message="Drop image or click here to select"
                          id="headerData_images"
                        />
                      </div>
                      <div class="placeholder-glow" v-else>
                        <span
                          class="placeholder w-100 placeholder-lg h-200"
                        ></span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label for="images">Guest XP Background </label>
                      <div v-if="!guestXPBgImgLoading">
                        <VueDropify
                          @upload="changeGuestXPBgImage($event)"
                          :src="
                            guest_xp_bg_image !== null ? guest_xp_bg_image : ''
                          "
                          message="Drop image or click here to select"
                          id="guest_xp_bg_image"
                        />
                      </div>
                      <div class="placeholder-glow" v-else>
                        <span
                          class="placeholder w-100 placeholder-lg h-200"
                        ></span>
                      </div>
                    </div>
                    <div class="mt-3">
                      <b-button
                        class="float-end ms-3"
                        variant="outline-primary"
                        @click="handleHeaderSubmit()"
                        :class="{
                          disabled: isHeaderDataBtnLoading,
                        }"
                      >
                        <i
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                          v-if="isHeaderDataBtnLoading"
                        ></i
                        >Save
                      </b-button>
                      <b-button
                        class="float-end"
                        variant="outline-primary"
                        @click="resetHeaderData()"
                        :class="{
                          disabled: isResetBtnLoading,
                        }"
                      >
                        <i
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                          v-if="isResetBtnLoading"
                        ></i
                        >Reset
                      </b-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div v-if="!isOnTemplate">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap"
              >
                <h4 class="mb-0">
                  Home Page
                  <span v-show="isShowLightBox">/ Light Box </span>
                </h4>
                <b-button
                  v-show="isShowLightBox"
                  class="float-end"
                  variant="outline-primary"
                  type="submit"
                  @click="addNewLightBox"
                >
                  Add New
                </b-button>
              </div>
              <hr />
              <LightBox v-if="isShowLightBox" :currentProps="lightBoxData" />
              <div class="category-scroll" v-else>
                <div class="row">
                  <template v-if="Pages.length == 0">
                    <div
                      class="col-xl-4 col-lg-12 col-md-6"
                      v-for="no in 21"
                      :key="no"
                    >
                      <div class="m-2 placeholder-glow">
                        <span
                          class="placeholder placeholder-lg w-100"
                          style="height: 25px"
                        ></span>
                      </div>
                    </div>
                  </template>
                  <div
                    class="col-xl-6 col-lg-12 col-md-6"
                    v-for="(menu, index) in Pages"
                    :key="index"
                  >
                    <div
                      class="form-check form-switch form-switch-md mb-4 d-flex category-options mx-1"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="menu.name"
                        v-model="menu.is_active"
                        @click="changeStatus(menu)"
                        :disabled="menu.isShow !== undefined && !menu.isShow"
                      />
                      <label
                        :for="menu.name"
                        class="form-check-label"
                        :class="
                          menu.isShow !== undefined && !menu.isShow
                            ? 'text-decoration-line-through'
                            : ''
                        "
                      >
                        {{ menu.name }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Open category page-->
      <div v-if="isShowCategory">
        <CategoryPage :currentProps="cardProps" @openHomePage="openCategory" />
      </div>
    </b-card>

    <!-- Drawer is use to Add New Category -->
    <Drawer
      @close="editPage"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="775"
    >
      <div v-if="pageDrawerOpen">
        <h4>{{ PageTitle }}</h4>
        <hr />
        <form ref="header-form" @submit.stop.prevent="handleMenuPageDataSubmit">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="button_name">
                Page Name <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="button_name"
                type="text"
                placeholder="Hotel Directory"
                autocomplete="off"
                v-model="PageData.name"
                :class="{
                  'is-invalid': submittedButtonData && $v.PageData.name.$error,
                }"
              />
              <div v-if="submittedButtonData" class="invalid-feedback">
                <span v-if="!$v.PageData.name.required"
                  >Page name is required.</span
                >
              </div>
            </div>
            <div class="col-md-6 mb-3" v-if="selectedTemplate.is_icon_template">
              <label for="button_icon"> Page Icon </label>
              <b-button
                variant="outline-primary"
                class="btn-sm ms-2"
                v-b-modal.icon-list-modal
                @click="setIcons"
                >Select Icon</b-button
              >
              <b-form-input
                id="button_icon"
                type="text"
                placeholder="fas fa-heading"
                autocomplete="off"
                v-model="PageData.icon"
                :class="{
                  'is-invalid': submittedButtonData && $v.PageData.icon.$error,
                }"
              />
              <div v-if="submittedButtonData" class="invalid-feedback">
                <span v-if="!$v.PageData.icon.required"
                  >Page icon is required.</span
                >
              </div>
            </div>
            <div class="col-md-12 mb-3" v-if="selectedTemplate.is_img_template">
              <label for="">Display Image</label>
              <VueDropify
                @upload="changeMenuPageDataImage($event)"
                :src="PageData.image"
                message="Drop image or click here to select"
                uploadIcon="fa fa-upload"
                id="header_image"
                class="w-100"
                :class="{
                  'is-invalid': submittedButtonData && $v.PageData.image.$error,
                }"
              />
              <div v-if="submittedButtonData" class="invalid-feedback">
                <span v-if="!$v.PageData.image.required"
                  >Page image is required.</span
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="mb-3">
                <label for="condition">
                  Display Condition <span class="text-danger">*</span>
                </label>
                <span class="m-2">
                  <b-button
                    id="Attach All"
                    @click="PageData.page_condition = conditionOption"
                    size="sm"
                    variant="primary"
                    >Attach All</b-button
                  >
                </span>
                <b-button
                  id="Detach All"
                  @click="PageData.page_condition = []"
                  size="sm"
                  variant="primary"
                  >Detach All</b-button
                >
                <MultiSelect
                  v-model="PageData.page_condition"
                  :options="conditionOption"
                  :show-labels="false"
                  track-by="value"
                  label="text"
                  :multiple="true"
                />
              </div>
            </div>
            <template v-if="PageData.is_active_super_panel == undefined">
              <label>Template Type</label>
              <div class="col-md-3 mb-3">
                <div class="position-relative template_page_type cursor">
                  <img
                    src="@/assets/images/pageContentList/list_page_first.png"
                    alt="list_one"
                    class="w-100 me-3"
                    @click="selectedListType('list_page_first')"
                  />

                  <b-form-checkbox
                    id="list_page_first"
                    v-model="page_template_type"
                    class="form-check font-size-20"
                    value="list_page_first"
                    @click="selectedListType('list_page_first')"
                  ></b-form-checkbox>
                </div>
                <p class="mb-0 text-dark text-center">List Page First</p>
              </div>
              <div class="col-md-3 mb-3">
                <div class="position-relative template_page_type cursor">
                  <img
                    src="@/assets/images/pageContentList/list_page_second.png"
                    alt="list_one"
                    class="w-100 me-3"
                    @click="selectedListType('list_page_second')"
                  />

                  <b-form-checkbox
                    id="list_page_second"
                    v-model="page_template_type"
                    class="form-check font-size-20"
                    value="list_page_second"
                    @click="selectedListType('list_page_second')"
                  ></b-form-checkbox>
                </div>
                <p class="mb-0 text-dark text-center">List Page Second</p>
              </div>
              <div class="col-md-3 mb-3">
                <div class="position-relative template_page_type cursor">
                  <img
                    src="@/assets/images/pageContentList/content_page.png"
                    alt="list_one"
                    class="w-100 me-3"
                    @click="selectedListType('content_page')"
                  />
                  <b-form-checkbox
                    id="content_page"
                    v-model="page_template_type"
                    class="form-check font-size-20"
                    value="content_page"
                    @click="selectedListType('content_page')"
                  ></b-form-checkbox>
                </div>
                <p class="mb-0 text-dark text-center">Content Page</p>
              </div>
              <div class="col-md-3 mb-3">
                <div class="position-relative template_page_type cursor">
                  <img
                    src="@/assets/images/pageContentList/redirect-url.png"
                    alt="list_one"
                    class="w-100 me-3"
                    @click="selectedListType('redirect_url')"
                  />
                  <b-form-checkbox
                    id="redirect_url"
                    v-model="page_template_type"
                    class="form-check font-size-20"
                    value="redirect_url"
                    @click="selectedListType('redirect_url')"
                  />
                </div>
                <p class="mb-0 text-dark text-center">Redirect URL</p>
              </div>
              <div
                class="col-md-12"
                v-if="page_template_type == 'redirect_url'"
              >
                <label for="add_url"> Add URL </label>
                <b-form-input
                  id="add_url"
                  type="text"
                  placeholder="Enter Menu Redirect Url ( Like : https://www.google.com/ )"
                  autocomplete="off"
                  v-model="PageData.redirect_url"
                  :dimensions="{ height: '100%', width: '100%' }"
                  :class="{
                    'is-invalid':
                      submittedButtonData && $v.PageData.redirect_url.$error,
                  }"
                ></b-form-input>
                <div v-if="submittedButtonData" class="invalid-feedback">
                  <span v-if="!$v.PageData.redirect_url.required"
                    >URL is required.</span
                  >
                  <span v-if="!$v.PageData.redirect_url.url"
                    >Enter valid URL.</span
                  >
                </div>
              </div>
            </template>

            <div class="col-md-12">
              <hr />

              <b-button
                class="float-end ms-2"
                variant="outline-primary"
                type="reset"
                @click="editPage"
                >Cancel</b-button
              >
              <b-button
                class="float-end"
                variant="outline-primary"
                :class="{ disabled: isButtonDataBtnLoading }"
                @click="handleMenuPageDataSubmit"
                ><i
                  v-if="isButtonDataBtnLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i
                >{{ isPageEdit ? "Update" : "Save" }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </Drawer>

    <!-- Modal is for add new folio -->
    <b-modal id="icon-list-modal" size="xl" centered hide-footer hide-header>
      <div class="row">
        <b-tabs justified nav-class="nav-tabs-custom" content-class="pt-3">
          <b-tab v-for="(icon, index) in typeBaseIcons" :key="index">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ icon.iconName }}</span>
            </template>
            <div class="row icon-demo-content" id="solid">
              <div
                class="col-xl-3 col-lg-4 col-sm-6"
                v-for="(icon, iconIndex) in icon.icons"
                :key="iconIndex"
                @click="setIcon(icon)"
              >
                <i :class="icon.icon"></i>{{ icon.show }}
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.template-dropdown {
  position: absolute;
  right: 0;
  top: 0;
}
.option-image {
  width: 50px;
}
.banner-img {
  height: 100px;
}
.bg-img {
  width: 100%;
  height: 540px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow-y: auto;
}
.border-gray {
  width: 50px;
  border-radius: 4px;
  border: 1px solid #ced4da;
}
.color-box {
  height: 20px;
  margin: 7.52px;
  border-radius: 4px;
  border: 1px solid #ced4da;
}
.select-color {
  position: absolute;
  z-index: 1000;
}
.update-color {
  position: absolute;
  right: -8px;
  top: -10px;
  padding: 4px 6px;
  font-size: 10px;
  border-radius: 50%;
  z-index: 1100;
  background-color: #2d2d2d;
}
.bottom-drawer {
  bottom: 2px;
  left: 3px;
  position: absolute;
  width: 338px;
}

.bottom-drawer .body-area {
  background: #2d2d2d;
  overflow: hidden;
}
.bottom-drawer .body-area .control-box {
  width: 60px;
  height: 60px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
}
.bottom-drawer .body-area .control-box i {
  font-size: 20px;
  line-height: 1;
}
.bottom-drawer .body-area .control-box:hover {
  cursor: pointer;
  color: #fff;
  background-color: #656d7e;
}
.control-range {
  width: 200px;
  height: 2px;
  margin: auto;
}
.btn-group {
  display: flex;
  justify-content: space-around;
}
.btn-group .floating-btn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.4);
  color: var(--template-menu-font);
  border: 1px solid var(--template-theme-border);
  background-color: var(--template-menu-bg);
}
.booking-box {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.4);
}
.date-box {
  min-width: 100px;
  min-height: 80px;
  margin: 0px 8px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.4);
}
.booking-btn,
.booking-btn:hover {
  background-color: var(--template-btn-bg);
  color: var(--template-btn-font);
  border: 1px solid var(--template-btn-border);
}

.color-box-theme {
  background-color: var(--template-theme);
}
.color-box-theme-border {
  background-color: var(--template-theme-border);
}
.color-box-theme-font {
  background-color: var(--template-theme-font);
}
.color-box-theme-icon {
  background-color: var(--template-theme-icon);
}
.color-box-title-bg {
  background-color: var(--template-title-bg);
}
.color-box-title-font {
  background-color: var(--template-title-font);
}
.color-box-menu-bg {
  background-color: var(--template-menu-bg);
}
.color-box-menu-font {
  background-color: var(--template-menu-font);
}
.color-box-btn-bg {
  background-color: var(--template-btn-bg);
}
.color-box-btn-font {
  background-color: var(--template-btn-font);
}
.color-box-btn-border {
  background-color: var(--template-btn-border);
}
</style>

<style>
.dropify-upload-logo .has-icon {
  z-index: 9 !important;
}

.template_page_type .form-check {
  position: absolute;
  top: 6px;
  right: 6px;
}
</style>
